import { FileText, User, Clock, FileCheck, Globe, Monitor, FileType, Star, Users, Target, Calendar } from "lucide-react"
import { Input } from "../ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select"
import { Textarea } from "../ui/textarea"
import { Badge } from "../ui/badge"

import { Row, Col, Typography  } from '../ui/ot'
import BaseInfoBlock1 from "./base_info_block_1"
import BaseInfoBlock2 from "./base_info_block_2"
import { useEffect, useState } from "react"

const BaseInfoBlock = ({
    title = "樣式基本資訊",
    description = "設定樣式的基本資訊，包括標題、儲存資料夾和標籤",
    titleLevel = 3,
    fieldConfigs1 = [],
    fieldConfigs2 = [],
    fieldConfigs3 = [],
    fieldValues = {},
    formSubmitCheck = false, 
    onDataChange = () => {},
    onFinish = () => {}, 
}) => {
    const [formData, setFormData] = useState([]);
    const [config1, setConfig1] = useState(false);
    const [config2, setConfig2] = useState(false);
    const [config3, setConfig3] = useState(false);


    useEffect(() => {
        onDataChange(formData)
    }, [formData])
    useEffect(() => {
        if(config1 && config2 && config3) {
            onFinish(true, formData)
            setConfig1(false)
            setConfig2(false)
            setConfig3(false)
        }
    }, [config1, config2, config3])


    return (
        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
        {/* 標題區塊 */}
        <div className="flex items-start gap-3 mb-6 pb-4 border-b border-blue-100">
            <FileText className="text-blue-500 mt-1" size={24} />
            <div>
            <Typography.Title 
                // className="text-xl font-bold text-gray-800"
                level={titleLevel}
            >
                {title}
            </Typography.Title>
            <Row>{description}</Row>
            </div>
        </div>

        <BaseInfoBlock1 
            columnCount={3}
            onValuesChange={(values) => {
                setFormData((item) => {
                    return {
                        ...item,
                        ...values
                    }
                })
            }}
            fieldConfigs={fieldConfigs1}
            fieldValues={fieldValues}
            formSubmitCheck={formSubmitCheck}
            onFinish={(values) => {
                // console.log({values})
                const validKeys = fieldConfigs1.map(cfg => cfg.name);
                const filteredValues = Object.keys(values).reduce((acc, key) => {
                    if (validKeys.includes(key)) {
                    acc[key] = values[key];
                    }
                    return acc;
                }, {});
                setFormData((pre) => {
                    return {
                        ...pre, 
                        ...filteredValues,
                    }
                })
                setConfig1(true)
            }}
        />
        <BaseInfoBlock2 
            columnCount={4}
            onValuesChange={(values) => {
                setFormData((item) => {
                    return {
                        ...item,
                        ...values
                    }
                })
            }}
            fieldConfigs={fieldConfigs2}
            fieldValues={fieldValues}
            formSubmitCheck={formSubmitCheck}
            onFinish={(values) => {
                // console.log({values})
                const validKeys = fieldConfigs2.map(cfg => cfg.name);
                const filteredValues = Object.keys(values).reduce((acc, key) => {
                    if (validKeys.includes(key)) {
                    acc[key] = values[key];
                    }
                    return acc;
                }, {});
                setFormData((pre) => {
                    return {
                        ...pre, 
                        ...filteredValues,
                    }
                })
                setConfig2(true)
            }}
        />
        <BaseInfoBlock1 
            columnCount={1}
            onValuesChange={(values) => {
                setFormData((item) => {
                    return {
                        ...item,
                        ...values
                    }
                })
            }}
            // fieldConfigs={[
            //     {
            //         name: "description",
            //         label: "範本描述", 
            //         labelIcon: "", 
            //         labelCSS: "block text-sm font-medium text-gray-700 mb-1", 
            //         component: <></>, 
            //         componentType: "TEXTAREA", 
            //         placeholder: "請輸入範本的詳細描述，包括目的、目標受眾和關鍵信息等", 
            //         badge: false, 
            //         badgeName: "", 
            //         labelContent: "", 
            //         property_option_json: [], 
            //         order: 0, 
            //         disabled: false, 
            //         hidden: false,
            //     },
            // ]}
            fieldConfigs={fieldConfigs3}
            fieldValues={fieldValues}
            formSubmitCheck={formSubmitCheck}
            onFinish={(values) => {
                // console.log({values})
                const validKeys = fieldConfigs3.map(cfg => cfg.name);
                const filteredValues = Object.keys(values).reduce((acc, key) => {
                    if (validKeys.includes(key)) {
                    acc[key] = values[key];
                    }
                    return acc;
                }, {});
                setFormData((pre) => {
                    return {
                        ...pre, 
                        ...filteredValues,
                    }
                })
                setConfig3(true)
            }}
        />
        </div>
    )
}

export default BaseInfoBlock;